import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button6", component(opts));
  editor.BlockManager.add("button6", block(opts));
};